// Helper to fetch content via the local Cloudflare Worker proxy.
// This avoids CORS issues when fetching Gutenberg/Gutendex content.

export async function fetchViaWorker(url: string): Promise<Response> {
    const encodedUrl = encodeURIComponent(url);
    // Use the relative API path which will be intercepted by Vite proxy (dev) or Cloudflare Worker (prod)
    const proxyUrl = `/api/fetch?url=${encodedUrl}`;

    console.debug(`[fetchProxy] Requesting: ${proxyUrl} (upstream: ${url})`);

    const response = await fetch(proxyUrl);

    console.debug(`[fetchProxy] Response: ${response.status} ${response.statusText}`, {
        contentType: response.headers.get('content-type')
    });

    if (!response.ok) {
        let errorText = '';
        let jsonError: any = null;

        try {
            errorText = await response.text();
            try {
                jsonError = JSON.parse(errorText);
            } catch {
                // Not JSON
            }
        } catch (readErr) {
            // Cannot read body
            errorText = '[Body Read Failed]';
        }

        if (jsonError && typeof jsonError === 'object') {
            if (jsonError.code) {
                // Structured worker error
                const code = jsonError.code;
                const status = jsonError.status || response.status;
                const url = jsonError.url || 'unknown';

                if (code === 'upstream_status') {
                    throw new Error(`Upstream Error: Server returned ${status} for ${url}`);
                }
                if (code === 'blocked_host') {
                    throw new Error(`Security: Host ${jsonError.host} is not in the allowlist.`);
                }
                if (code === 'route_missing') {
                    throw new Error(`Worker Error: Route missing (404)`);
                }
                throw new Error(`Worker Error [${code}]: ${jsonError.error || 'Unknown error'}`);
            }
            // Fallback for simple JSON error
            if (jsonError.error) {
                throw new Error(`Worker Error: ${jsonError.error}`);
            }
        }

        if (errorText.length > 300) errorText = errorText.substring(0, 300) + '...';
        throw new Error(`Proxy Fetch Failed: ${response.status} ${response.statusText}${errorText ? ' - ' + errorText : ''}`);
    }

    return response;
}



export async function fetchTextViaWorker(url: string): Promise<string> {
    const response = await fetchViaWorker(url);
    return response.text();
}

export async function fetchArrayBufferViaWorker(url: string): Promise<ArrayBuffer> {
    const response = await fetchViaWorker(url);
    return response.arrayBuffer();
}
